import { Authenticator } from '@aws-amplify/ui-react';
import { ToastViewport } from '@nrg/design-system';
import { Outlet } from 'react-router';
import AuthRouteSwitch from '@/auth/components/AuthRouteSwitch';

// Every route is authenticated. If a public (token-based) route ever lands,
// reintroduce a gate that allow-lists it before the auth switch (a
// ConditionalAuthGate doing exactly that existed until Aug 2026 — git history).
export default function RootLayout() {
  return (
    <>
      <Authenticator.Provider>
        <AuthRouteSwitch>
          <Outlet />
        </AuthRouteSwitch>
      </Authenticator.Provider>
      <ToastViewport />
    </>
  );
}
